import {Component, ElementRef, Input, HostBinding, OnInit} from '@angular/core';
import { SpotlightProductsComponent } from './spotlight.products.component';


/**
 * Wrapper component to integrate correctly in non-angular frontend of the website
 *   OR
 * to integrate in a place where binding @Input parameters doesn't work as expected, ie. when loading as content
 * of [innerHtml].
 *
 * @author evandongen
 */
@Component({
    selector: 'spotlight-products-wrapper-component',
    template: `<spotlight-products
    [description]="description"
    [filterUrl]="filterUrl"
    [origin]="origin"
    [showAll]="showAll"
    [title]="title"></spotlight-products>`,
    standalone: true,
    imports: [SpotlightProductsComponent]
})


export class SpotlightProductsWrapperComponent implements OnInit {
	dataDescription: string;
	dataFilterUrl: string;
	dataOrigin: string;
	dataShowAll: boolean;
	dataTitle: string;

	@Input('data-title') @HostBinding('attr.data-title') attrTitle: string;
	@Input('data-origin') @HostBinding('attr.data-origin') attrOrigin: string;
	@Input('data-description') @HostBinding('attr.data-description') attrDescription: string;
	@Input('data-filterurl') @HostBinding('attr.data-filterurl') attrFilterUrl: string;
	@Input('data-showall') @HostBinding('attr.data-showall') attrShowAll: boolean;

	description: string;
	filterUrl: string;
	origin: string;
	showAll: boolean;
	title: string;

	constructor(private domElement: ElementRef) {
		const nativeDomElement = domElement.nativeElement;

		this.dataFilterUrl = nativeDomElement.getAttribute('data-filterurl');
		this.dataShowAll = nativeDomElement.getAttribute('data-showall');
		this.dataTitle = nativeDomElement.getAttribute('data-title');
		this.dataDescription = nativeDomElement.getAttribute('data-description');
		this.dataOrigin = nativeDomElement.getAttribute('data-origin');
	}

	ngOnInit() {
		this.title = this.useCorrectStringValueOrMergeIfSame(this.dataTitle, this.attrTitle);
		this.description = this.useCorrectStringValueOrMergeIfSame(this.dataDescription, this.attrDescription);
		this.filterUrl = this.useCorrectStringValueOrMergeIfSame(this.dataFilterUrl, this.attrFilterUrl);
		this.origin = this.useCorrectStringValueOrMergeIfSame(this.dataOrigin, this.attrOrigin);
		this.showAll = this.useCorrectBooleanValueOrMergeIfSame(this.dataShowAll, this.attrShowAll);
	}

	private useCorrectBooleanValueOrMergeIfSame(dataValue: boolean, attrValue: boolean): boolean {
		if (dataValue && !attrValue) {
			return dataValue;
		}

		if (!dataValue && attrValue) {
			return attrValue;
		}

		if (dataValue === attrValue) {
			return dataValue;
		}

		return false;
	}

	private useCorrectStringValueOrMergeIfSame(dataValue: string, attrValue: string): string {
		if (!dataValue && !attrValue) {
			return '';
		}

		if (dataValue && !attrValue) {
			return dataValue;
		}

		if (!dataValue && attrValue) {
			return attrValue;
		}

		if (dataValue.toLowerCase() === attrValue.toLowerCase()) {
			return dataValue;
		}

		return '';
	}

}
